// extracted by mini-css-extract-plugin
export var text = "_bc-0";